import { useSelector } from 'react-redux'

import { selectCurrentUser } from '../state/selectors'

export type Preferences = {
  lang: string
  locId: string
}

export type Addon = {
  prices: {
    [currency: string]: number
  }
  limits: {
    [limitType: string]: number
  }
}

interface Subscription {
  tier: string
  planMustMigrate: boolean
  planInterval: string
  subscriptionStatus: string
  unit_amount: number
  currency: string
  bfATPPromoClaimed: boolean
  reactivationAvailable: boolean
  subscriptionPlan: string
  pastDueStartedAt: string
  latestInvoiceData?: {
    amountPaid: number
  } | null
}

export interface User {
  id: string
  email: string
  created_at?: number
  preferences: Preferences
  countryCode?: string
  lifetime_offer_until?: number
  free_trial_used?: number
  user_group: string
  addons: Record<string, Addon>
  subscription: Subscription | null
  city: string
  country: string
  tier?: string
  payment_account_created_at?: number
  multi_user_type?: string
  user_type?: string
  affiliation?: string
  flags?: {
    onboarding_survey_submitted?: boolean
    [key: string]: boolean | undefined
  }
}

export const useUser = () => {
  const user = useSelector<unknown, User>(selectCurrentUser())
  return user
}
